<template>
  <div class="row">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title">Tambah Produk</h5>
      </div>
      <div class="card-body">
        <div class="card">
          <div class="alert alert-info" id="notif">
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">
                <i class="now-ui-icons text-dark ui-1_simple-remove"></i>
              </span>
            </button>
            <span
              ><i class="fa fa-info-circle" aria-hidden="true"></i> Pilih Layout
              Terlebih dahulu</span
            >
          </div>

            <div class="card-header">
              <div class="panel-group mb-3" style="cursor:pointer;" id="accordion">
                <!-- First Panel -->
                <div class="panel panel-default ">
                  <div class="panel-heading bg-soft-secondary pl-3 pb-1 rounded pr-3 pt-3">
                    <h5 class="panel-title" data-toggle="collapse" data-target="#_chooseLayout">Pilih Layout</h5>
                  </div>
                  
                  <div id="_chooseLayout" class="panel-collapse collapse show">
                    <div class="panel-body">
                      <form action=""  @submit.prevent="goLayout">
                        <!-- <main class="collapse show" id="_chooseLayout"> -->
                          <div class="form-check"   v-for="(opt, index) in option" :key="index">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              :value="opt.value"
                              :id="'flexRadioDefault' + (index + 1)"
                              v-model="layout"
                            />
                            <label
                              :class="'form-check-label' + ' radio' + (index + 1)"
                              :for="'flexRadioDefault' + (index + 1)"
                            >
                              {{ opt.name }}
                            </label>
                          </div>
                        <!-- </main> -->
                        <button id="goLayout" type="submit" @click="goLayout" class="btn btn-primary">
                          <span id="goText"> Cari Layout</span>
                          <span
                            id="spinnerSpan"
                            v-if="isLoading"
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                        <!-- <button class="btn btn-secondary" @click="back">Kembali</button> -->
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

        <div id="layoutin">
          <LayoutBuku v-if="layoutByQuery ==  1"></LayoutBuku>
          <LayoutNonBuku v-if="layoutByQuery ==  3"></LayoutNonBuku>
          <LayoutJasa v-if="layoutByQuery ==  4"></LayoutJasa>
          <LayoutMassal v-if="layoutByQuery ==  5"></LayoutMassal>
          <LayoutPraKatalog v-if="layoutByQuery ==  6"></LayoutPraKatalog>
        </div>
        <div class="card">
          <p id="valOrder"></p>
        </div>
      </div>
      <div class="card-footer"></div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import Vue from "vue";
import $ from "jquery";
import LayoutBuku from "./Layout/LayoutBuku/LayoutBuku";
import LayoutNonBuku from "./Layout/LayoutNonBuku/LayoutNonBuku";
import LayoutJasa from "./Layout/LayoutJasa/LayoutJasa";
import LayoutMassal from "./Layout/LayoutMassal/LayoutMassal";
import LayoutPraKatalog from "./Layout/LayoutPraKatalog/LayoutPraKatalog";

// import { orderObj } from "./order";
// import axios from 'axios'
export default {
  components: {
    LayoutBuku,
    LayoutNonBuku,
    LayoutJasa,
    LayoutMassal,
    LayoutPraKatalog,
  },
  data() {
    return {
      valOrder: "",
      option: [
        {
          name: "Pra Katalog",
          value: 1,
        },
        {
          name: "Barang",
          value: 3,
        },
        {
          name: "Jasa",
          value: 4,
        },
        {
          name: "Upload Masal",
          value: 5,
        },
      ],
      clearable: false,
      layout: '',
      whatLayout: 0,
      isLoading: false,
    };
  },
  created() {
    this.layout = this.layoutByQuery
    Vue.component("vue-select", VueSelect);
  },
  watch:{
    layout(){
      // console.log(this.layout)
    }
  },
  computed:{
    layoutByQuery(){
      return this.$route.query.layout
    }
  },
  methods: {
    goLayout() { 
      this.$router.replace({ path: 'addproduct', query: { layout: this.layout }}).catch(()=>{})
      $("#goLayout").attr("disabled", "true");
      this.isLoading = true;
      $("#goText").hide();
      $("#notif").fadeOut("slow");

      if (this.layout === 1) {
        const hideEl = $('#_chooseLayout').collapse('hide') 
        hideEl
        setTimeout(() => {
          // $(".radio1").addClass("badge badge-soft-primary");
          // $(".radio2").removeClass("badge badge-soft-primary");
          $("#goText").show();
          $("#goLayout").removeAttr("disabled");
          this.isLoading = false;
          this.whatLayout = 1;
        }, 420);
      } else if (this.layout === 3) {
        const hideEl = $('#_chooseLayout').collapse('hide') 
        hideEl
        setTimeout(() => {
          // $("#flexRadioDefault2").prop("checked", true);
          // $(".radio3").addClass("badge badge-soft-primary");
          // $(".radio1").removeClass("badge badge-soft-primary");
          $("#goText").show();
          $("#goLayout").removeAttr("disabled");
          this.isLoading = false;
          this.whatLayout = 3;
        }, 420);
      } else if (this.layout === 5) {
        const hideEl = $('#_chooseLayout').collapse('hide') 
        hideEl
        setTimeout(() => {
          // $("#flexRadioDefault3").prop("checked", true);
          // $(".radio4").addClass("badge badge-soft-primary");
          // $(".radio1").removeClass("badge badge-soft-primary");
          $("#goText").show();
          $("#goLayout").removeAttr("disabled");
          this.isLoading = false;
          this.whatLayout = 5;
        }, 420);
      } else if (this.layout === 4) {
        const hideEl = $('#_chooseLayout').collapse('hide') 
        hideEl
        setTimeout(() => {
          // $("#flexRadioDefault4").prop("checked", true);
          // $(".radio5").addClass("badge badge-soft-primary");
          // $(".radio1").removeClass("badge badge-soft-primary");
          $("#goText").show();
          $("#goLayout").removeAttr("disabled");
          this.isLoading = false;
          this.whatLayout = 4;
        }, 420);
      } else {
        this.$swal.fire(
          "Perhatian!",
          "Pilih Layout terlebih dahulu",
          "warning"
        );

        this.isLoading = false;
        $("#goText").show();
        $("#notif").fadeIn("slow");
        $("#goLayout").removeAttr("disabled");
      }
    },
    back() {
      window.history.back();
    },
  },
  mounted() {
    // this.valOrder =
    // var order = {}
  },
};
</script>

<style scoped>
.panel-title {
  position: relative;
}
  
.panel-title::after {
  content: "\f107";
  color: #333;
  top: -2px;
  right: 0px;
  position: absolute;
  font-family: "FontAwesome"
}

.panel-title[aria-expanded="true"]::after {
  content: "\f106";
}

/*
 * Added 12-27-20 to showcase full title clickthrough
 */

.panel-heading-full.panel-heading {
  padding: 0;
}

.panel-heading-full .panel-title {
  padding: 10px 15px;
}

.panel-heading-full .panel-title::after {
  top: 10px;
  right: 15px;
}

</style>